<template>
  <div v-if="item" :class="`bg-${readonly ? 'white' : 'light-gray'} rounded`">
    <div class="row p-2 p-lg-3">
      <div class="col-12 col-lg pt-2 pt-lg-0">
        <CustomInputDisplay
          label="Categoría de Alternativa:"
          label-class="text-gray font-weight-light"
          :value="item.category"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg pt-2 pt-lg-0">
        <CustomInputDisplay
          label="Nombre de Alternativa:"
          label-class="text-gray font-weight-light"
          :value="item.name"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg pt-2 pt-lg-0">
        <CustomInputDisplay
          label="Total de Estudiantes:"
          label-class="text-gray font-weight-light"
          :value="item.numberOfStudents"
          empty-text="0"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg pt-2 pt-lg-0">
        <CustomInputDisplay
          label="Cupo de Estudiantes:"
          label-class="text-gray font-weight-light"
          :value="item.studentCapacity"
          empty-text="0"
          class="font-weight-bold"
        />
      </div>
      <div class="col-12 col-lg pt-2 pt-lg-0">
        <CustomInputDisplay
          label="Grado:"
          label-class="text-gray font-weight-light"
          :value="item.shortNameGrades"
          class="font-weight-bold"
        />
      </div>
      <div
        :class="
          `col-12 col-lg${
            readonly ? '' : '-1'
          } pt-2 pt-lg-0 order-last order-lg-0`
        "
      >
        <div
          class="h-100 d-flex flex-row align-items-center justify-content-end pt-3 pt-lg-0"
        >
          <template v-if="readonly">
            <div class="w-100 w-lg-0">
              <div
                class="text-white text-center p-2 rounded"
                :style="{ 'background-color': '#E2E2E2' }"
              >
                <i
                  :class="[
                    'fas fa-fw',
                    { 'fa-minus': none },
                    { 'fa-check': accepted },
                    { 'fa-times-circle': rejected },
                  ]"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <ActionButton
              :variant="`${rejected ? '' : 'outline-'}danger`"
              i="fas fa-times-circle"
              class="w-100 w-lg-0 btn-check-state"
              @click="reject"
            />
            <div class="mx-1" />
            <ActionButton
              :variant="`${accepted ? '' : 'outline-'}success`"
              i="fas fa-check"
              class="w-100 w-lg-0 btn-check-state"
              @click="accept"
            />
          </template>
        </div>
      </div>
      <div v-if="rejected" class="col-12">
        <div
          :style="{ 'border-top': '1px solid #E2E2E2', margin: '.5rem 0' }"
        />
        <div class="row">
          <template v-if="readonly">
            <div class="col-12 col-lg-5 pt-2 pt-lg-0">
              <CustomInputDisplay
                label="Fecha:"
                label-class="text-gray font-weight-light"
                :value="item.reasonDate"
                class="font-weight-bold"
              />
            </div>
            <div class="col-12 col-lg-5 pt-2 pt-lg-0">
              <CustomInputDisplay
                label="Razón:"
                label-class="text-gray font-weight-light"
                :value="item.reason"
                class="font-weight-bold"
              />
            </div>
          </template>
          <template v-else>
            <div class="col-12">
              <div class="mb-2">
                <i
                  class="fas fa-times-circle text-orange bg-white rounded-circle"
                  :style="{ padding: '2px' }"
                />
                <span class="ml-2 font-weight-light">Razón de Rechazo</span>
              </div>
            </div>
            <div class="col-12 col-md-3 col-lg-2 pt-2 pt-lg-0">
              <CustomDatePicker
                label="Fecha:"
                regular-label
                class-container="w-100"
                disabled
                :value="new Date()"
              />
            </div>
            <div class="col-12 col-md-9 col-lg-10 pt-2 pt-lg-0">
              <ValidationProvider
                v-slot="{ errors, validate }"
                mode="lazy"
                rules="required"
                :custom-messages="{ required: 'Favor escriba razón.' }"
              >
                <CustomTextArea
                  v-model="item.reason"
                  label="Razón:"
                  regular-label
                  show-char-count
                  :maxlength="3000"
                  :count-classes="['d-block text-right']"
                  :error="errors[0]"
                  :custom-error-msg="errors[0]"
                  @input="validate"
                />
              </ValidationProvider>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomTextArea from 'CustomTextArea';
import { schoolAlternativeDecisionEnum } from '../../../_types';

export default {
  name: 'SchoolAlternativeItem',
  components: {
    CustomInputDisplay,
    ActionButton,
    CustomDatePicker,
    CustomTextArea,
  },
  props: {
    /* SchoolRecommendationAlternativeModel */
    item: { type: Object, required: true, default: null },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    none() {
      return this.item?.decision === schoolAlternativeDecisionEnum.None;
    },
    accepted: {
      get() {
        return this.item?.decision === schoolAlternativeDecisionEnum.Accepted;
      },
      set(value) {
        this.item.decision = value;
      },
    },
    rejected: {
      get() {
        return this.item?.decision === schoolAlternativeDecisionEnum.Rejected;
      },
      set(value) {
        this.item.decision = value;
      },
    },
  },
  methods: {
    accept() {
      if (this.accepted) {
        this.accepted = schoolAlternativeDecisionEnum.None;
      } else if (this.rejected || this.none) {
        this.accepted = schoolAlternativeDecisionEnum.Accepted;
      }
      this.$emit('accepted');
    },
    reject() {
      if (this.rejected) {
        this.rejected = schoolAlternativeDecisionEnum.None;
      } else if (this.accepted || this.none) {
        this.rejected = schoolAlternativeDecisionEnum.Rejected;
      }
      this.$emit('rejected');
    },
  },
};
</script>

<style lang="scss" scoped>
.w-lg-0 {
  @media (min-width: 992px) {
    width: inherit !important;
  }
}

::v-deep .btn-check-state {
  i {
    margin-right: 0px !important;
  }

  &.danger {
    &:focus {
      outline: 0 !important;
      box-shadow: 0 0 0 0.2rem rgba(201, 84, 94, 0.5) !important;
    }
  }
}
</style>
